<template>
    <div class="popup">
        <div
            class="popup-cover"
            @click.stop="closePopup"
        ></div>
        <div class="popup-con">
            <div class="title">预约提醒</div>
            <div
                class="hint"
            >
                游戏上线后将通过短信通知您
            </div>
            <div
                class="ipt"
                :class="{'red': isErrNum}"
            >
                <div class="phone-district">+86</div>
                <input
                    v-model="phoneVal"
                    class="input"
                    type="number"
                    maxlength="11"
                    placeholder="请输入手机号"
                    @input="onInput"
                >
                <div
                    v-if="isErrNum"
                    class="phone-format"
                >
                    号码格式有误
                </div>
            </div>
            <div class="btn">
                <div
                    class="close-btn"
                    @click.stop="closePopup"
                >
                    关闭
                </div>
                <div
                    class="use-msg-btn"
                    :class="{'primary' : phoneVal.length > 0}"
                    @click.stop="useMsg"
                >
                    使用短信通知
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import api from '@/api';
    import { getQueryString} from '@/utils/url';
    import { eventBus } from '../../index';
    export default {
        props: {
            bookedText: {
                type: String,
                default: '已预约'
            }
        },
        data() {
            return {
                phoneVal: '', // input框的值
                isErrNum: false, // 输入的手机号是否有误
                popupName: {
                    popupName: '短信预约'
                }
            }
        },
        created() {
            let phoneVal = JSON.parse(this.getLocalStorage());
            if (phoneVal) {
                this.phoneVal = phoneVal;
            }
            this.doDisplayLog();
        },
        methods: {
            closePopup() {
                this.$emit('checkPopupStatus');
                this.doClickLog('close');
            },
            async useMsg() {
                this.doClickLog('messageReser');
                if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.phoneVal))) {
                    this.isErrNum = true;
                    this.doClickLog('smsNotice');
                    return;
                }
                let params = {
                    data: {
                        'app_id': getQueryString('appId'),
                        'phone_number': this.phoneVal,
                        'auto_download': false
                    }
                }
                let res = await api.zone.appointmentGame(params);
                // flag是针对英雄联盟活动多次预约文案变化问题
                const flag = true;
                if (res.isSuccess || flag) {
                    this.closePopup();
                    this.$toast('预约成功');
                    this.setLocalStorage(this.phoneVal);
                    this.$emit('bookSuccess');
                    eventBus.$emit('updateText', this.bookedText);
                }
            },
            setLocalStorage(phoneVal) {
                localStorage.setItem('appointment_phone', JSON.stringify(phoneVal));
            },
            getLocalStorage() {
                return localStorage.getItem('appointment_phone');
            },
            onInput() {
                this.phoneVal = this.phoneVal.slice(0,11);
            },
            doDisplayLog() {
                this.$logger.display({
                    value: 'popup',
                    ext: {
                        item: [
                            {
                                id: '',
                                ext: Object.assign(this.popupName, this.$root.extData),
                                pos: ''
                            }
                        ]
                    }
                });
            },
            doClickLog(value) {
                this.$logger.click({
                    value,
                    ext: {
                        id: '',
                        ext: Object.assign(this.popupName, this.$root.extData),
                        pos: ""
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "~@/common/style/mixin/utils";
    $design-width: 1242;
    .popup {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 10000;
        .popup-cover {
            background-color: #000000;
            opacity: 0.65;
            width: 100%;
            height: 100%;
        }
        .popup-con {
            position: absolute;
            width: px2rem(993);
            background-color: #fff;
            left: 50%;
            transform: translateX(-50%);
            top: px2rem(792);
            border-radius: px2rem(39);
            .title {
                font-size: px2rem(72);
                text-align: center;
                margin-top: px2rem(84);
                color: #333;
            }
            .hint {
                font-size: px2rem(48);
                text-align: center;
                margin-top: px2rem(42);
                color: #999;
            }
            .ipt {
                display: flex;
                position: relative;
                margin-top: px2rem(51);
                width: px2rem(891);
                margin-left: px2rem(51);
                padding: px2rem(38) 0;
                border: px2rem(3) solid;
                border-radius: px2rem(9);
                border-color:  #ccc;
                .phone-district {
                    width: px2rem(98);
                    font-size: px2rem(54);
                    color: #999;
                    border-right: px2rem(1) solid #ccc;
                    padding: 0 px2rem(30);
                    margin-right: px2rem(30);
                }
                .input {
                    font-size: px2rem(48);
                    background: none;  
                    outline: none;  
                    border: none;
                    width: px2rem(400);
                }
                input::-webkit-input-placeholder {
                    color: #999999;
                }
                .phone-format {
                    position: absolute;
                    right: px2rem(30);
                    align-self: center;
                    font-family: PingFangSC-Regular;
                    font-size: px2rem(42);
                    color: #FC5353;
                    letter-spacing: 0;
                    text-align: right;
                    line-height: px2rem(48);
                    font-weight: 400;
                }
            }
            .red {
                border-color: #EC4345;
            }
            .text-red {
                color: #EC4345;
            }
            .btn {
                margin-top: px2rem(86);
                border-top: px2rem(1) solid #ccc;
                width: 100%;
                height: px2rem(147);
                font-size: px2rem(54);
                display: flex;
                .close-btn {
                    width: 50%;
                    font-size: px2rem(54);
                    line-height: px2rem(147);
                    text-align: center;
                    border-right: px2rem(1) solid #ccc;
                }
                .use-msg-btn {
                    width: calc(50% - 1px);
                    text-align: center;
                    line-height: px2rem(147);
                    color: #cccccc;
                }
                .primary {
                    color: #3388FF;
                }
            }
        }
    }
</style>